import * as React from 'react';

interface ChevronLeftIconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
  width?: number;
  height?: number;
}

const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({
  fillColor = '#212124',
  width = 16,
  height = 16,
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.7433 3.66896L11.4123 2.92567L9.92567 1.58774L9.25671 2.33104L10.7433 3.66896ZM5.5 8L4.75671 7.33104L4.1546 8L4.75671 8.66896L5.5 8ZM9.25671 13.669L9.92567 14.4123L11.4123 13.0743L10.7433 12.331L9.25671 13.669ZM9.25671 2.33104L4.75671 7.33104L6.24329 8.66896L10.7433 3.66896L9.25671 2.33104ZM4.75671 8.66896L9.25671 13.669L10.7433 12.331L6.24329 7.33104L4.75671 8.66896Z"
      fill={fillColor}
    />
  </svg>
);

export default ChevronLeftIcon;
